import { bootstrap, type AppConfig } from "@usable/office-shell";
import { outlookToolSchemas, handleOutlookToolCall } from "./lib/outlook-tools";
import { outlookContextProvider } from "./lib/outlook-context";

// The whole Outlook add-in: host-specific mailbox tools + config; the shared
// shell does the rest. Logo + ribbon icons come from @usable/office-assets.
//
// EMBED TOKEN: the dedicated Outlook embed (task f000669b) — its mail-tuned,
// stateless system prompt lives in Usable fragment dbf3c457-9cb9-4679-8a57-
// 48282a97cd12 ("Prompt — Usable Outlook Assistant").

// Microsoft Graph (NAA) capability — mailbox/calendar-wide reads. Enabled only
// when the app registration is baked in at build time (GRAPH_CLIENT_ID +
// GRAPH_TENANT_ID via @usable/build-config's DefinePlugin); otherwise the whole
// `graph` block is omitted and Outlook runs with just the Office.js item tools.
// The authority MUST be tenant-specific for the single-tenant app reg
// (`/common` errors AADSTS50194). Scopes are the read-only union consented once.
const graphClientId = process.env.GRAPH_CLIENT_ID;
const graphTenantId = process.env.GRAPH_TENANT_ID;
const graph: AppConfig["graph"] =
  graphClientId && graphTenantId
    ? {
        clientId: graphClientId,
        authority: `https://login.microsoftonline.com/${graphTenantId}`,
        scopes: ["Mail.Read", "Calendars.Read"],
      }
    : undefined;

bootstrap({
  appName: "Outlook Assistant",
  documentNoun: "email",
  embedToken:
    process.env.EMBED_TOKEN ??
    "uc_4983e55ddba3e8c4c0b8bc208849c18ccfdc7de403eb8544e61c23b64bf9bd98",
  dbName: "usable-outlook-chat-history",
  toolSchemas: outlookToolSchemas,
  onToolCall: handleOutlookToolCall,
  contextProvider: outlookContextProvider,
  graph,
});
